import { track } from 'lib/drip';

export function doTrack(applicationId: number, name: string) {
  track('action', {
    application_id: applicationId,
    name: `curators-${name}`,
  });
}
